module.exports = __webpack_public_path__ + "static/media/PlagiarismIllustration.9d1f6cbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PlagiarismLock/assets/PlagiarismIllustration.svg
// module id = 5270
// module chunks = 11